import {APP_PREFIX_PATH} from '@/constants/route.constant'
import {NAV_ITEM_TYPE_ITEM, NAV_ITEM_TYPE_TITLE,} from '@/constants/navigation.constant'
import {Permissions} from "@/constants/app.constant";
import {MdOutlineHistory} from "react-icons/md";
import {GoVersions} from "react-icons/go";
import {LuUserCog, LuUsers} from "react-icons/lu";

const manageNavigationConfig = [
    {
        key: 'manage',
        path: '',
        title: 'مدیریت',
        translateKey: '',
        icon: '',
        type: NAV_ITEM_TYPE_TITLE,
        permissions: [Permissions.manage.value],
        subMenu: [
            {
                key: 'users',
                path: `${APP_PREFIX_PATH}/users`,
                title: 'کاربران',
                translateKey: 'کاربران',
                icon: 'LuUsers',
                type: NAV_ITEM_TYPE_ITEM,
                permissions: [Permissions.manage.users.value],
                subMenu: [],
            },
            {
                key: 'roles',
                path: `${APP_PREFIX_PATH}/roles`,
                title: 'نقش‌ها',
                translateKey: 'نقش‌ها',
                icon: 'LuUserCog',
                type: NAV_ITEM_TYPE_ITEM,
                permissions: [Permissions.manage.roles.value],
                subMenu: [],
            },
            {
                key: 'media',
                path: `${APP_PREFIX_PATH}/media`,
                title: 'رسانه',
                translateKey: 'رسانه',
                icon: 'MdPermMedia',
                type: NAV_ITEM_TYPE_ITEM,
                permissions: [Permissions.manage.media.value],
                subMenu: [],
            },
            {
                key: 'notifications',
                path: `${APP_PREFIX_PATH}/notifications`,
                title: 'اعلان‌ها',
                translateKey: 'اعلان‌ها',
                icon: 'HiOutlineBell',
                type: NAV_ITEM_TYPE_ITEM,
                permissions: [Permissions.manage.notifications.value],
                subMenu: [],
            },
            {
                key: 'sms',
                path: `${APP_PREFIX_PATH}/sms`,
                title: 'پیامک‌ها',
                translateKey: 'پیامک‌ها',
                icon: 'FaCommentSms',
                type: NAV_ITEM_TYPE_ITEM,
                permissions: [Permissions.manage.sms.value],
                subMenu: [],
            },
            {
                key: 'plugins',
                path: `${APP_PREFIX_PATH}/plugins`,
                title: 'افزونه‌ها',
                translateKey: 'افزونه‌ها',
                icon: 'BsPlugin',
                type: NAV_ITEM_TYPE_ITEM,
                permissions: [Permissions.manage.plugins.value],
                subMenu: [],
            },
            {
                key: 'apps',
                path: `${APP_PREFIX_PATH}/apps`,
                title: 'اپ‌ها',
                translateKey: 'اپ‌ها',
                icon: 'FaAppStore',
                type: NAV_ITEM_TYPE_ITEM,
                permissions: [Permissions.manage.apps.value],
                subMenu: [],
            },
            /*{
                key: 'versions',
                path: `${APP_PREFIX_PATH}/versions`,
                title: 'نسخه‌ها',
                translateKey: 'نسخه‌ها',
                icon: 'GoVersions',
                type: NAV_ITEM_TYPE_ITEM,
                permissions: [Permissions.manage.versions.value],
                subMenu: [],
            },*/
            {
                key: 'settings',
                path: `${APP_PREFIX_PATH}/settings`,
                title: 'تنظیمات',
                translateKey: 'تنظیمات',
                icon: 'MdSettings',
                type: NAV_ITEM_TYPE_ITEM,
                permissions: [Permissions.manage.settings.value],
                subMenu: [],
            },
            {
                key: 'logs',
                path: `${APP_PREFIX_PATH}/logs`,
                title: 'تاریخچه',
                translateKey: 'تاریخچه',
                icon: 'MdOutlineHistory',
                type: NAV_ITEM_TYPE_ITEM,
                permissions: [Permissions.manage.logs.value],
                subMenu: [],
            },
        ]
    }
]

export default manageNavigationConfig
